import React, { useMemo, useState } from 'react';
import { Button, Card } from 'react-bootstrap';

import { GridGetterFunction } from '../../../common/components/Grid/GridDataTypes';
import {
  CreateUpdateJobConfigDto,
  GetJobConfigDto,
  ResponseError,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import {
  convert,
  validate,
} from '../../../common/spdCore/contexts/JobConfigContext';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { JobConfigSearch } from '../../components/JobConfig/JobConfigSearch';
import { JobConfigEditor } from '../../components/JobConfig/JobConfigEditor';
import { Waiting } from '../../../common/components/Waiting/Waiting';

export const JobConfigView: React.FC = () => {
  const [jobConfig, setJobConfig] = useState<GetJobConfigDto>();
  const [show, setShow] = useState(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const spd = useSpdCore();
  const [waiting, setWaiting] = useState<boolean>(false);

  const addEditJobConfig = async (
    jobConfigCU: CreateUpdateJobConfigDto,
    id?: string,
  ) => {
    const status = await validate(jobConfigCU);
    if (status.valid) {
      try {
        if (id) {
          await spd.jobConfig.update(id, jobConfigCU);
        } else {
          await spd.jobConfig.create(jobConfigCU);
        }
        setShow(false);
        setRefresh(!refresh);
        return {
          saved: true,
          errors: [],
        };
      } catch (response) {
        return {
          saved: false,
          errors: await responseErrors(response as ResponseError),
        };
      }
    } else {
      return {
        saved: false,
        errors: status.errors,
      };
    }
  };

  const onRowClick = async (id: string) => {
    const getJobConfig = await spd.jobConfig.getById(id);
    setJobConfig(getJobConfig);
    setShow(true);
  };

  const handleAdd = () => {
    setJobConfig(undefined);
    setShow(true);
  };

  const handleClose = () => {
    setJobConfig(undefined);
    setShow(false);
  };

  const synchronizeJobs = async () => {
    setWaiting(true);
    spd.jobConfig
      .synchronizeAllJobs()
      .then(() => {
        setRefresh(!refresh);
        setWaiting(false);
      })
      .catch(() => {
        setWaiting(false);
      });
  };

  const getData = useMemo(
    () =>
      ((pageSize, pageNumber, orderBy, orderDirection, filterText) =>
        spd.jobConfig.getAllByPortion(
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
        )) as GridGetterFunction,
    [spd],
  );

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">Konfiguracja zadań cyklicznych</Card.Title>
        <Button className="mb-4" variant="outline-primary" onClick={handleAdd}>
          Dodaj
        </Button>
        {!waiting && (
          <JobConfigSearch
            getData={getData}
            getCount={spd.jobConfig.getAllCount}
            onRowClick={onRowClick}
            refresh={refresh}
          />
        )}
        <JobConfigEditor
          jobConfig={convert(jobConfig)}
          readOnly={false}
          show={show}
          handleClose={handleClose}
          onCompleted={addEditJobConfig}
          id={jobConfig?.id}
          systemNumber={jobConfig?.systemNumber}
        />
        {waiting && <Waiting />}
        <Button variant="outline-primary" onClick={synchronizeJobs}>
          Synchronizuj zadania
        </Button>
      </Card.Body>
    </Card>
  );
};
